interface IPromotionTypes {
  promotionCode: string;
  // goto: string;
  member: string;
  official: string;
  consecutiveStay: string;
}

export const PromotionTypes: IPromotionTypes = {
  promotionCode: "promotion_code",
  // goto: "goto",
  member: "member",
  official: "official",
  consecutiveStay: "consecutive_stay",
};
